 <template>
  <Banner class="PlayerProfile">
    <template slot="header">
      <h1>
        <BattleTag :tag="$route.params.name"></BattleTag>
      </h1>
    </template>

    <template slot="caption">
      <Loader
        :url="urlList"
        v-model="profiles"
        @ready="onReady"
      >
      </Loader>
    </template>

    <template
      slot="controls"
      v-if="profiles.length"
    >
      <Picker
        v-model="selected"
        :tree="tree"
        :save="$route.params.name"
      >
      </Picker>
    </template>

    <template>
      <template slot="tabs">
        <Tab to="/">Overview</Tab>
        <Tab to="/games">Match History</Tab>
        <Tab to="/statistics">Statistics</Tab>
        <Tab to="/peers">Peers</Tab>

        <div class="Banner-controls">
          <!-- <router-link
            class="Button"
            v-tooltip="'Leaderboard'"
            :to="{
              name: map,
              params: {
                tab: 'leaderboard'
              }
            }"
          ><i class="fas fa-table"></i></router-link> -->
        </div>
      </template>

      <template
        slot="content"
        v-if="profiles.length"
      >
        <Loader
          :url="urlProfile"
          :model="Profile"
          v-model="profile"
        >
          <template
            v-if="profile"
            slot="result"
          >
            <Overview
              v-if="isTab ()"
              :key="`overview-${JSON.stringify (selected)}`"
              :profile="profile"
            ></Overview>

            <Statistics
              v-if="isTab ('statistics')"
              :key="`statistics-${JSON.stringify (selected)}`"
              :id="profile.stats [0].id"
            ></Statistics>

            <GameDirectory
              v-if="isTab ('games')"
              :key="`games-${JSON.stringify (selected)}`"
              :pk="selected"
              :for="profile.name"
            ></GameDirectory>

            <!--<Games      v-if="isTab ('games')"      :account="account" :profile="profile"></Games> -->

            <Peers
              v-if="isTab ('peers')"
              :profile="profile"
            ></Peers>
          </template>
        </Loader>
      </template>
    </template>
  </Banner>
</template>

<script>
  import config from '@/config';
  import Banner from '@/legacy/components/layout/Banner';
  import Tab from '@/legacy/components/widgets/Tab';
  import Loader from '@/legacy/components/widgets/Loader';
  import Picker from '@/legacy/components/widgets/Picker';
  import BattleTag from '@/legacy/components/widgets/BattleTag';
  import Statistics from '@/legacy/components/Statistics';
  import GameDirectory from '@/legacy/components/GameDirectory';
  import Key from '@/legacy/lib//model/Key';
  import Profile from '@/legacy/lib//model/Profile';
  import Menu from '@/legacy/lib//model/Menu';
  import Games from '@/legacy/views/player/Games';;
  import Overview from '@/legacy/views/player/Overview';
  import Peers from '@/legacy/views/player/Peers';
  import PickerTree from '@/legacy/lib//model/PickerTree';

  import { httpBuildQuery, date, strcasecmp, filterByKey, urlencode } from '@/legacy/lib//util';
  import { isTab, capitalize, metaFactory } from '@/legacy/lib//template';

  export default {
    metaInfo () {
      if (!this.profile) {
        return;
      }

      return metaFactory ({
        title: this.profile.name,
        description: `Player profile for ${this.profile.name}. Rating: ${this.profile.rating}, Last Played: ${date (this.profile.lastPlayed)}.`,
        noindex: true
      })
    },

    components: {
      Banner,
      Tab,
      Loader,
      Picker,
      GameDirectory,
      Overview,
      Statistics,
      Games,
      BattleTag,
      Peers
    },

    data: function () {
      return {
        profiles : [],
        profile  : null,
        tree     : null,
        selected : new Key ()
      };
    },

    // beforeUpdate () {
      // if (
      //   this.profile &&
      //   strcasecmp (this.$route.params.name, this.profile.name) !== 0
      // ) {
      //   this.profiles = [];
      //   this.profile = null;
      // }
    // },

    computed: {
      urlList () {
        return httpBuildQuery (
          `/profiles/${urlencode (this.$route.params.name)}`
        );
      },

      urlProfile () {
        return `/profiles/${urlencode (this.$route.params.name)}/${filterByKey (this.profiles, this.selected) [0].id}`
      }
    },

    methods: {
      isTab,
      capitalize,
      Profile,

      onReady () {
        this.tree = new PickerTree ();

        for (let profile of this.profiles) {
          this.tree.add (profile.key);
        }

        this.tree.setDefaults ({
          round : 'Global',
          mode  : 'Global'
        });
      }
    }
  };
</script>

<style lang="scss">
  .PlayerProfile {
    .PageGutter {
      background-color: rgba(0, 0, 0, 0.15);
      background: asset('background/player.jpg') center no-repeat;
      background-size: cover;
      border-bottom: fetch(border faint);
    }

    .PageHeader {
      .Icon {
        color: rgba(var(--tan), 1);
        text-shadow: fetch(shadow text header);
      }
    }
  }
</style>